/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuccessfulResponse as DigiworkMaitreDApiConfigurationModelSuccessfulResponse } from '../../models/Digiwork/MaitreD/Api/Configuration/Model/successful-response';
import { AddOrderDto as DigiworkMaitreDPosDtoOrderV2AddOrderDto } from '../../models/Digiwork/MaitreD/Pos/DTO/OrderV2/add-order-dto';

export interface AddOrder_1$Params {
      body?: DigiworkMaitreDPosDtoOrderV2AddOrderDto
}

export function addOrder_1(http: HttpClient, rootUrl: string, params?: AddOrder_1$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>> {
  const rb = new RequestBuilder(rootUrl, addOrder_1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>;
    })
  );
}

addOrder_1.PATH = '/api/orders';
